/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import React from "react";
import { arrayOf, bool, string, object, oneOf } from "prop-types";
import classNames from "classnames/bind";
import merge from "lodash.mergewith";
import { Img } from "../Images";
import { CardLogo } from "../Card/Logo/CardLogo";
import * as sharedStyles from "./MultiImageBlock.module.scss";

let cx = classNames.bind(sharedStyles);

const MultiImageBlock = ({
	images,
	logo,
	logoPosition,
	populateImagesRightToLeft,
	populateImagesAsRows,
	columnProportions,
	photoCredit,
	styles,
}) => {
	cx = classNames.bind(merge(sharedStyles, styles));

	let oneImageColumn = false;

	if (images.length < 3) {
		oneImageColumn = true;
	}

	let columnClasses = null;

	if (oneImageColumn) {
		columnClasses = cx("imageCol", "imageColCustom", "imageColFull", "imageColFullCustom");
	} else if (populateImagesAsRows) {
		if (populateImagesRightToLeft) {
			if (columnProportions === "2/3") {
				columnClasses = cx(
					"imageRow",
					"imageRowCustom",
					"flexReverse",
					"flexReverseCustom",
					"oneThird",
					"oneThirdCustom"
				);
			} else if (columnProportions === "3/4") {
				columnClasses = cx(
					"imageRow",
					"imageRowCustom",
					"flexReverse",
					"flexReverseCustom",
					"oneQuarter",
					"oneQuarterCustom"
				);
			} else {
				columnClasses = cx("imageRow", "imageRowCustom", "flexReverse", "flexReverseCustom");
			}
		} else if (columnProportions === "2/3") {
			columnClasses = cx("imageRow", "imageRowCustom", "twoThirds", "twoThirdsCustom");
		} else if (columnProportions === "3/4") {
			columnClasses = cx("imageRow", "imageRowCustom", "threeQuarters", "threeQuartersCustom");
		} else {
			columnClasses = cx("imageRow", "imageRowCustom");
		}
	} else if (columnProportions === "2/3") {
		if (populateImagesRightToLeft) {
			columnClasses = cx("imageCol", "imageColCustom", "oneThird", "oneThirdCustom");
		} else {
			columnClasses = cx("imageCol", "imageColCustom", "twoThirds", "twoThirdsCustom");
		}
	} else if (columnProportions === "3/4") {
		if (populateImagesRightToLeft) {
			columnClasses = cx("imageCol", "imageColCustom", "oneQuarter", "oneQuarterCustom");
		} else {
			columnClasses = cx("imageCol", "imageColCustom", "threeQuarters", "threeQuartersCustom");
		}
	} else {
		columnClasses = cx("imageCol", "imageColCustom");
	}

	const groupSize = 2;
	const imageColumns = images
		.map(image => (
			<div key={image.id} className={cx("imageContainer", "imageContainerCustom")}>
				<Img
					fluid={image?.fluid}
					alt={image?.title}
					src={image?.src}
					wrapperClassName={cx("image")}
				/>
				{logo && logo.length > 0 && (
					<CardLogo logo={logo?.fluid} alt={logo?.alt} logoPosition={logoPosition} />
				)}
				{/* {logo && <CardLogo logo={logo?.fluid} alt={logo?.alt} logoPosition={logoPosition} />} */}
				{photoCredit && <p className={cx("photoCredit")}>{photoCredit}</p>}
			</div>
		))
		.reduce((col, element, index) => {
			if (index % groupSize === 0) {
				col.push([]);
			}
			col[col.length - 1].push(element);
			return col;
		}, [])
		.map(columnContent => (
			<div key={`img-col-${columnContent[0].id}`} className={columnClasses}>
				{columnContent}
			</div>
		));

	return (
		<div className={cx("multiImageBlockContainer")}>
			{images && (
				<div className={cx("column", "columnCustom")}>
					<div
						className={
							populateImagesRightToLeft
								? cx("imageGroup", "imageGroupCustom", "flexReverse", "flexReverseCustom")
								: cx("imageGroup", "imageGroupCustom")
						}>
						{imageColumns}
					</div>
				</div>
			)}
		</div>
	);
};

MultiImageBlock.propTypes = {
	images: arrayOf(object),
	logo: arrayOf(object),
	logoPosition: oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
	populateImagesRightToLeft: bool,
	populateImagesAsRows: bool,
	columnProportions: string,
	photoCredit: string,
	styles: object,
};
MultiImageBlock.defaultProps = {
	images: [],
	logo: [],
	logoPosition: undefined,
	populateImagesRightToLeft: false,
	populateImagesAsRows: false,
	columnProportions: "1/2",
	photoCredit: "",
	styles: null,
};

export default MultiImageBlock;
export { MultiImageBlock };
